<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props: {
    // An ID for the modal element, to be used with v-b-modal.the-id
    modalId: {
      type: String,
      default: "support-modal",
    },
  },

  data() {
    return {
      // The name sent with this support message -- not used if the
      // user is logged in
      name: "",

      // The email of the user sending the support message -- not used if
      // the user is logged in
      email: "",

      // The subject of the support message
      subject: "",

      // The body of the support message
      body: "",
    };
  },

  // Mapped vuex state
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["authenticated", "activeTeam"]),
  },

  methods: {
    // Send the support message to the API
    async contactSupport() {
      let success = await this.addSupportMessage({
        subject: this.subject + " (#" + this.activeTeam.handle + ")",
        body: this.body,
        name: this.authenticated ? this.user.name : this.name,
        email: this.authenticated ? this.user.email : this.email,
      });

      // If it was successful, clear the modal and hide it
      if (success) {
        this.hide();
        this.name = "";
        this.email = "";
        this.body = "";
        this.subject = "";
      }
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Other mapped vuex actions
    ...mapActions(["addSupportMessage"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Contact support"
    button-size="sm"
    hide-header-close
    no-close-on-backdrop
  >
    <p class="my-2">
      <b-form id="support-form" @submit.stop.prevent="contactSupport">
        <b-row v-if="!authenticated">
          <b-col>
            <b-form-group label="Name" label-for="name">
              <b-form-input
                required
                v-model="name"
                id="name"
                placeholder="Name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Email" label-for="email">
              <b-form-input
                required
                v-model="email"
                id="email"
                placeholder="Email"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Subject" label-for="subject">
          <b-form-input
            required
            v-model="subject"
            id="subject"
            :placeholder="'Subject (#' + this.activeTeam.handle + ')'"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Message" label-for="message">
          <b-form-textarea
            required
            v-model="body"
            id="message"
            placeholder="Describe your question..."
            rows="6"
            no-resize
          ></b-form-textarea>
        </b-form-group>
      </b-form>
    </p>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button type="submit" form="support-form" variant="success">
          Send Message
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
